import { BaseConstruction } from '../constructions/BaseConstruction';
import { SVGRenderer } from '../core/SVGRenderer';
import { Compass } from '../objects/Compass';
import { Ruler } from '../objects/Ruler';

export type ConstructionConstructor = new (
  renderer: SVGRenderer,
  compass: Compass,
  ruler: Ruler
) => BaseConstruction;

export class ConstructionRegistry {
  private static registry: Map<string, ConstructionConstructor> = new Map();
  private static metadata: Map<string, { title: string; category: string; grade: string }> = new Map();

  public static register(
    id: string,
    ctor: ConstructionConstructor,
    info: { title: string; category: string; grade: string } = { title: id, category: 'General', grade: 'Grade 1-10' }
  ): void {
    this.registry.set(id.toLowerCase(), ctor);
    this.metadata.set(id.toLowerCase(), info);
  }

  public static get(id: string): ConstructionConstructor | undefined {
    return this.registry.get(id.toLowerCase());
  }

  public static has(id: string): boolean {
    return this.registry.has(id.toLowerCase());
  }

  public static listAll(): Array<{ id: string; title: string; category: string; grade: string }> {
    const list: Array<{ id: string; title: string; category: string; grade: string }> = [];
    this.metadata.forEach((info, id) => {
      list.push({ id, ...info });
    });
    return list;
  }
}
